import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../../../../../app.settings';

@Injectable({
  providedIn: 'root'
})
export class ProgressService {

  progressMonitorUrl = `${AppSettings.API_ENDPOINT}/${'get-speech-recognition-progress-list'}`;

  constructor(private http: HttpClient) { }

  getProgress(){
    return this.http.get(this.progressMonitorUrl);
  }
}
